import type { IBookmakerPageApi } from '@/types/bookmaker';

export class BookmakerItem {
    public bettingErrorStop: string | null;
    public code: string;
    public id: number;
    public isActive: 0 | 1;
    public maintenanceFrom: string | null;
    public name: string;
    public url: string;

    constructor(data: IBookmakerPageApi) {
        this.id = data.id;
        this.code = data.code;
        this.name = data.name;
        this.url = data.url;
        this.maintenanceFrom = data.maintenance_from;
        this.bettingErrorStop = data.betting_error_stop;
        this.isActive = data.is_active;
    }

    get active(): 0 | 1 {
        return this.isActive;
    }

    get betting(): number {
        // If betting_error_stop is null, betting is running (1), otherwise stopped (0)
        return this.bettingErrorStop === null ? 1 : 0;
    }

    get maintenance(): string | null {
        return this.maintenanceFrom;
    }
}
